import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import RfqServices from '@Services/purchase/rfq/rfqServices';
import RfqActions, { rfqActionTypes } from '@Actions/purchase/rfq/rfqActions';

/**
 * @param action
 */
function* _getRfq(action) {
  try {
    yield put(RfqActions.getRfqLoading(true));
    const {
      orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list
    } = action;
    const rfqs = yield RfqServices.getRfq(orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list);
    yield put(RfqActions.getRfqSuccess(rfqs));
    yield put(RfqActions.getRfqLoading(false));
  } catch (error) {
    yield put(RfqActions.getRfqLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.GET_RFQ.ERROR, error));
  }
}

/**
 *
 */
function* getRfq() {
  yield takeLatest(rfqActionTypes.GET_RFQ.REQUEST, _getRfq);
}
/**
 * @param action
 */
function* _createRfq(action) {
  try {
    yield put(RfqActions.createRfqLoading(true));
    const rfq = yield RfqServices.createRfq(action.payload);
    if (rfq.success) {
      yield put(TrackerActions.trackAction(rfqActionTypes.CREATE_RFQ.SUCCESS, rfq.data));
      notification.open({
        type: 'success',
        message: 'Request for quotation successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.createRfqLoading(false));
      if (action.callback) {
        action.callback(rfq?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.createRfqLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.CREATE_RFQ.ERROR, error));
    yield put(RfqActions.createRfqLoading(false));
  }
}

/**
 *
 */
function* createRfq() {
  yield takeLatest(rfqActionTypes.CREATE_RFQ.REQUEST, _createRfq);
}

/**
 *
 * @param {*} action
 */
function* _updateRfq(action) {
  try {
    yield put(RfqActions.updateRfqLoading(true));
    const rfq = yield RfqServices.updateRfq(action.payload);
    if (rfq.success) {
      yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ.SUCCESS, rfq.data));
      notification.open({
        type: 'success',
        message: 'Request for quotation updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ.ERROR, error));
    yield put(RfqActions.updateRfqLoading(false));
  }
}

/**
 *
 */
function* updateRfq() {
  yield takeLatest(rfqActionTypes.UPDATE_RFQ.REQUEST, _updateRfq);
}

/**
 *
 * @param {*} action
 */
function* _updateRfqParticipant(action) {
  try {
    yield put(RfqActions.updateRfqParticipantLoading(true));
    const rfq = yield RfqServices.updateRfqParticipant(action.payload);
    if (rfq.success) {
      yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ.SUCCESS, rfq.data));
      notification.open({
        type: 'success',
        message: 'Request for quotation updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqParticipantLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqParticipantLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ_PARTICIPANT.ERROR, error));
    yield put(RfqActions.updateRfqParticipantLoading(false));
  }
}

/**
 *
 */
function* updateRfqParticipant() {
  yield takeLatest(rfqActionTypes.UPDATE_RFQ_PARTICIPANT.REQUEST, _updateRfqParticipant);
}

/**
 *
 * @param {*} action
 */
function* _updateRfqConfig(action) {
  try {
    yield put(RfqActions.updateRfqConfigLoading(true));
    const rfq = yield RfqServices.updateRfqConfig(action.payload);
    if (rfq.success) {
      yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ.SUCCESS, rfq.data));
      notification.open({
        type: 'success',
        message: 'Request for quotation updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqConfigLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.updateRfqConfigLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_RFQ_CONFIG.ERROR, error));
    yield put(RfqActions.updateRfqConfigLoading(false));
  }
}

/**
 *
 */
function* updateRfqConfig() {
  yield takeLatest(rfqActionTypes.UPDATE_RFQ_CONFIG.REQUEST, _updateRfqConfig);
}

/**
 * @param action
 */
function* _getRfqById(action) {
  try {
    const {
      orgId, tenantId, rfqId, callback, dontShowLoading,
    } = action;
    if (!dontShowLoading) {
      yield put(RfqActions.getRfqByIdLoading(true));
    }
    const selectedRfq = yield RfqServices.getRfqById(orgId, tenantId, rfqId);
    yield put(RfqActions.getRfqByIdSuccess(selectedRfq?.rfq_list?.[0]));
    if (callback) {
      action.callback(selectedRfq?.rfq_list?.[0]);
    }
    yield put(RfqActions.getRfqByIdLoading(false));
  } catch (error) {
    yield put(RfqActions.getRfqByIdLoading(false));
    yield put(TrackerActions.trackAction(rfqActionTypes.GET_RFQ_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getRfqById() {
  yield takeLatest(rfqActionTypes.GET_RFQ_BY_ID.REQUEST, _getRfqById);
}

/**
 * @param action
 */
function* _sendRfqNotification(action) {
  try {
    yield put(RfqActions.sendRfqNotificationLoading(true));
    const rfq = yield RfqServices.sendRfqNotification(action.payload);
    if (rfq.success) {
      yield put(TrackerActions.trackAction(rfqActionTypes.CREATE_RFQ.SUCCESS, rfq.data));
      notification.open({
        type: 'success',
        message: 'Request for quotation notification sent successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.sendRfqNotificationLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(RfqActions.sendRfqNotificationLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.SEND_RFQ_NOTIFICATION.ERROR, error));
    yield put(RfqActions.sendRfqNotificationLoading(false));
  }
}

/**
 *
 */
function* sendRfqNotification() {
  yield takeLatest(rfqActionTypes.SEND_RFQ_NOTIFICATION.REQUEST, _sendRfqNotification);
}

/**
 * @param action
 */
function* _deleteRfq(action) {
  try {
    yield put(RfqActions.deleteRfqLoading(true));
    const deletedPo = yield RfqServices.deleteRfq(action.payload);
    if (deletedPo.success) {
      notification.open({
        type: 'success',
        message: 'Request for quotation has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedPo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(RfqActions.deleteRfqLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.DELETE_RFQ.ERROR, error));
    yield put(RfqActions.deleteRfqLoading(false));
  }
}

/**
 *
 */
function* deleteRfq() {
  yield takeLatest(rfqActionTypes.DELETE_RFQ.REQUEST, _deleteRfq);
}

/**
 * @param action
 */
function* _updateRfqStatus(action) {
  try {
    yield put(RfqActions.updateRfqStatusLoading(true));
    const so = yield RfqServices.updateRfqStatus(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'RFQ status successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(RfqActions.updateRfqStatusLoading(false));
  } catch (error) {
    yield put(RfqActions.updateRfqStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.UPDATE_STATUS_RFQ.ERROR, error));
  }
}

/**
 *
 */
function* updateRfqStatus() {
  yield takeLatest(rfqActionTypes.UPDATE_STATUS_RFQ.REQUEST, _updateRfqStatus);
}

function* _getPublicRfq(action) {
  try {
    yield put(RfqActions.getPublicRfqLoading(true));
    const rfq = yield RfqServices.getPublicRfq(action?.accessToken);
    if (rfq.rfq?.length) {
      if (action?.callback) {
        action.callback(rfq);
      }
    } else {
      yield put(RfqActions.getPublicRfqError(rfq?.error));
    }
    yield put(RfqActions.getPublicRfqLoading(false));
  } catch (error) {
    yield put(RfqActions.getPublicRfqLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getPublicRfq() {
  yield takeLatest(rfqActionTypes.GET_PUBLIC_RFQ.REQUEST, _getPublicRfq);
}

function* _negotiationAction(action) {
  try {
    const { actionType, payload } = action;
    yield put(RfqActions.negotiationActionLoading(actionType, true));
    const rfq = yield RfqServices.negotiationAction(actionType, payload);
    if (rfq.success) {
      if (action?.callback) {
        action.callback();
      }
      let message = '';
      if (actionType === 'addNegotiation') message = 'Prices have been submitted successfully';
      if (message) {
        notification.open({
          type: 'success',
          message,
          duration: 5,
          placement: 'top',
        });
      }
    } else {
      notification.open({
        type: 'error',
        message: rfq?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(RfqActions.negotiationActionLoading(actionType, false));
  } catch (error) {
    yield put(RfqActions.negotiationActionLoading(action?.actionType, false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* negotiationAction() {
  yield takeLatest(rfqActionTypes.NEGOTIATION.REQUEST, _negotiationAction);
}

function* _getAcceptedOffers(action) {
  try {
    yield put(RfqActions.getAcceptedOffersLoading(true));
    const offers = yield RfqServices.getAcceptedOffers(action?.payload);
    if (offers?.success) {
      yield put(RfqActions.getAcceptedOffersSuccess(offers?.data?.tenant_level_lines));
      if (action?.callback) {
        action.callback();
      }
    }
    yield put(RfqActions.getAcceptedOffersLoading(false));
  } catch (error) {
    yield put(RfqActions.getAcceptedOffersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getAcceptedOffers() {
  yield takeLatest(rfqActionTypes.GET_ACCEPTED_OFFERS.REQUEST, _getAcceptedOffers);
}

/**
 * @param action
 */
function* _getRfqParticipantNegotiations(action) {
  try {
    yield put(RfqActions.getRfqParticipantNegotiationsLoading(true));
    const {
      rfqParticipantId, callback,
    } = action;
    const participantNegotiations = yield RfqServices.getRfqParticipantNegotiations(rfqParticipantId);
    yield put(RfqActions.getRfqParticipantNegotiationsSuccess(participantNegotiations));
    if (callback) {
      callback(participantNegotiations?.data);
    }
    yield put(RfqActions.getRfqParticipantNegotiationsLoading(false));
  } catch (error) {
    yield put(RfqActions.getRfqParticipantNegotiationsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.ERROR, error));
  }
}

/**
 *
 */
function* getRfqParticipantNegotiations() {
  yield takeLatest(rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.REQUEST, _getRfqParticipantNegotiations);
}

/**
 *
 */
export default function* rfqSaga() {
  yield all([
    getRfq(),
    createRfq(),
    updateRfq(),
    getRfqById(),
    deleteRfq(),
    sendRfqNotification(),
    updateRfqConfig(),
    updateRfqParticipant(),
    updateRfqStatus(),
    getPublicRfq(),
    negotiationAction(),
    getAcceptedOffers(),
    getRfqParticipantNegotiations(),
  ]);
}
